<template>
  <section>
    <div>
      If you want to create your own topic or manage an existing one, go to
      <router-link to="/topics">management&nbsp;</router-link> (requires an active subscription).
    </div>
    <br />
    <div v-if="collection.length">
      You have completed
      <strong>{{ progress.done }}</strong> tasks out of <strong>{{ progress.total }}</strong> in total
      <strong>{{ collection.length }}</strong> topic(s).
    </div>
    <div v-else class="onboarding">
      To start labeling you must be a member of one or more topics. It looks like you don't have a dataset(s) to label
      at this moment.
      <div class="onboarding-image-wrapper">
        <svg
          class="onboarding-image"
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          height="24"
          viewBox="0 0 24 24"
          width="24"
        >
          <g><rect fill="none" height="24" width="24" /></g>
          <g>
            <g />
            <g>
              <circle cx="12" cy="4" r="2" />
              <path
                d="M15.89,8.11C15.5,7.72,14.83,7,13.53,7c-0.21,0-1.42,0-2.54,0C8.24,6.99,6,4.75,6,2H4c0,3.16,2.11,5.84,5,6.71V22h2v-6h2 v6h2V10.05L18.95,14l1.41-1.41L15.89,8.11z"
              />
            </g>
          </g>
        </svg>
        <div>
          <yn-button color="primary" :disabled="isJoinRequstPending" @click="join">Join a public topic</yn-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Button from './../common/Button';

export default {
  components: {
    'yn-button': Button
  },
  props: {
    collection: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      isJoinRequstPending: s => s.labelling.isJoinRequstPending
    }),
    progress() {
      return this.collection.reduce(
        (result, value) => ({
          total: result.total + value.progress.total,
          done: result.done + value.progress.done
        }),
        { total: 0, done: 0 }
      );
    }
  },
  methods: {
    async join() {
      this.$router.push({ path: `/search` });
    }
  }
};
</script>

<style lang="scss" scoped>
.onboarding {
  .onboarding-image-wrapper {
    padding: 2rem 0;
    margin-bottom: 2rem;
    text-align: center;
  }
  .onboarding-image {
    width: 15rem;
    height: 15rem;
  }
}
</style>
